/** @module ProductSpec/RestoreAndUnlinkFromShapePlugin */
define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginMenu"
], function(declare,ToolbarPluginMenu) {

	return declare(ToolbarPluginMenu, {
		/**
         * Handles the visibility of "Restore From Shape" and "Unlink From Shape" Actions
         *
         * @param {Context} ctx
         */
		validatePlugin: function(ctx) {
			// summary: only display the action on Shape Size Chart
			var cache = ctx.cache;
			var sizeChart = cache.getNode(ctx.getContextNode().__Parent__);
			var parent = cache.getNode(sizeChart.__Parent__);
			return parent && parent.$Type == "Style";
		}
	});
});